export function getCurrentDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function getParams() {
    const params = new URLSearchParams(window.location.search);

    // Default values
    const defaultKeyword = 'anwar ibrahim';
    const defaultDate = getCurrentDate();

    // Convert the URLSearchParams object to a plain object
    let paramsObj = Array.from(params.entries()).reduce((obj, [key, value]) => {
        obj[key] = value;
        return obj;
    }, {});

    // Set default values for keyword and date if they're not present
    if (!paramsObj.keyword) {
        paramsObj.keyword = defaultKeyword;
    }
    if (!paramsObj.date) {
        paramsObj.date = defaultDate;
    }

    return paramsObj;
}